module.exports = __webpack_public_path__ + "static/media/pp.fa92d790.jpeg";